import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyDqXTbFuhuBM8IDKfJugHwhooQSfyiLeT0',
  authDomain: 'clone-60e58.firebaseapp.com',
  projectId: 'clone-60e58',
  storageBucket: 'clone-60e58.appspot.com',
  messagingSenderId: '1079071975369',
  appId: '1:1079071975369:web:6860f81f90a7cf22c62a18',
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { db, auth, provider };
